export function detectDeviceTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

export function timezoneOffsetLabel(timeZone, at = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat('en', { timeZone, timeZoneName: 'shortOffset' }).formatToParts(at);
    return (parts.find(part => part.type === 'timeZoneName')?.value || '').replace('GMT', 'UTC');
  } catch {
    return '';
  }
}
